import { WindowLocation } from '@reach/router';
import { activeLocale } from './activeLocale';
import { getSlug } from './getSlug';

export const localeUrl = (location: WindowLocation, locales?: string[]) =>
  getSlug(activeLocale(location, locales));
